import { Button, Input, Label, Typography } from 'components';
import { useTranslations } from 'next-intl';
import { ChangeEvent, FC, HTMLAttributes, useState } from 'react';

interface IFormAddUrl extends HTMLAttributes<HTMLInputElement> {
  onClose?: () => void;
  onChangeAttachUrl: (value: string) => void;
}

const FormAddUrl: FC<IFormAddUrl> = ({ onClose, onChangeAttachUrl }) => {
  const t = useTranslations();
  const [link, setLink] = useState('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => setLink(e.target.value);

  const handleApply = () => {
    setLink('');
    onChangeAttachUrl(link);
    onClose?.();
  };

  const handleClose = () => {
    setLink('');
    onClose?.();
  };

  return (
    <div className="p-3">
      <div className="flex flex-col">
        <Typography variant="medium3" className="!mt-0.5 text-tertiary-100 ">
          {t('buttons.attach_url')}
        </Typography>
        {false && (
          <div>
            <Label>{t('labels.text')}</Label>
            <Input placeholder={t('placeholders.text')} onChange={handleChange} />
          </div>
        )}
        <div>
          <Label>{t('labels.link')}</Label>
          <Input
            value={link || ''}
            placeholder={t('placeholders.enter_link')}
            onChange={handleChange}
            name="link"
            autoComplete="off"
            type="url"
            autoFocus
          />
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <Button
          size="small"
          variant="text"
          className="!w-8 rounded-full"
          label={t('buttons.cancel')}
          onClick={handleClose}
        />
        <Button
          size="small"
          color="secondary"
          className="!w-8 rounded-full"
          label={t('buttons.apply')}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default FormAddUrl;
